import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
import { router } from './router'
import store from './store';
import MetaInfo from 'vue-meta-info';
import AOS from 'aos'
import 'aos/dist/aos.css'
import animated from 'animate.css'
import global from './mixins/global';
Vue.use(animated)

import { Notification,Message,Button,Pagination,Select,Option} from 'element-ui';
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.use(Button);
Vue.use(Select);
Vue.use(Option);
Vue.use(Pagination);

// 播放器插件
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import './mixins/iconfont'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.mixin(
  global
);
AOS.init({
  once: true
});
Vue.use(MetaInfo);

import 'normalize.css';
import '@/style/pub-style.less';
import '@/style/font.css'
import '@/style/animate.min.css'


Vue.config.productionTip = false


const init = async () => {
  router.afterEach((to, from, next) => {
    setTimeout(() => {
      var _hmt = _hmt || [];
      (function () {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?6a596f140a53a7eeea38c1d4fc3b3f5a";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })();
    }, 0);
  });
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    mounted() {
      // You'll need this for renderAfterDocumentEvent.
      document.dispatchEvent(new Event('render-active'))
    },
    watch: {
      '$route'(to, from) {
        //监听
      }
    }
  })
}
init();



// WEBPACK FOOTER //
// ./src/main.js